<div class="container-fluid">
  <div class="d-flex h-100">
    <!-- Sidebar -->
    <div class="sidebar h-100 d-none d-lg-block" #sidebar>
      <div class="sidebar-wrapper">
        <div class="bar-head">
          <img src="assets/images/onboarding/newbrijjlogo.svg" style="height: 5rem; width: 6rem" />
        </div>
        <div class="bar-options">
          <ul class="list-unstyled mb-0">
            <!-- Dashboard -->
            <li class="tool-wrap" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="companyId == -1 ? '/admin-portal/admin-dashboard' : '/home'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <img src="../../../../assets/images/duo-icons_dashboard.svg" />
              </a>
              <span class="tool-tip">Dashboard</span>
            </li>

            <!-- Company Management -->
            <ng-template [ngxPermissionsOnly]="['Company:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/company-management/company-listing'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_building.svg" />
                </a>
                <span class="tool-tip">Company Management</span>
              </li>
            </ng-template>

            <!-- Subscription Management -->
            <ng-template [ngxPermissionsOnly]="['SubscriptionPlan:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/subscription/plans-listing'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_file.svg" />
                </a>
                <span class="tool-tip">Subscription Management</span>
              </li>
            </ng-template>

            <!-- User Management -->
            <ng-template [ngxPermissionsOnly]="['Role:View', 'User:View']">
              <li class="tool-wrap" *ngIf="companyId !== -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/company-portal/user-management/user'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_user.svg" />
                </a>
                <span class="tool-tip">User Management</span>
              </li>
            </ng-template>

            <ng-template [ngxPermissionsOnly]="['Role:View', 'User:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/user-management/users-listing'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img src="../../../../assets/images/duo-icons_user.svg" />
                </a>
                <span class="tool-tip">User Management</span>
              </li>
            </ng-template>

            <!-- Product Management -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[0].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(1)"
            >
              <ng-container
                *ngIf="
                  getMenuLink(
                    allMenus[0],
                    companyId == -1 ? '/admin-portal/brands' : '/company-portal/brands'
                  );
                  else noProductRedirect
                "
              >
                <a
                  [routerLink]="
                    getMenuLink(
                      allMenus[0],
                      companyId == -1 ? '/admin-portal/brands' : '/company-portal/brands'
                    )
                  "
                  [ngClass]="{ active: isMenuActive(allMenus[0]) }"
                >
                  <img
                    src="../../../../assets/images/ic_productManagment.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-container>
              <ng-template #noProductRedirect>
                <a [ngClass]="{ active: isMenuActive(allMenus[0]) }">
                  <img
                    src="../../../../assets/images/ic_productManagment.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-template>
              <span class="tool-tip">Product Management</span>
            </li>

            <!-- Data Management -->
            <ng-template
              [ngxPermissionsOnly]="[
                'Brand:View',
                'ProductAttribute:View',
                'ProductCategory:View',
                'ProductDepartment:View',
                'StoreGroup:View',
                'StoreType:View',
              ]"
            >
              <li
                class="tool-wrap"
                *ngIf="companyId == -1 && allMenus[3].submenus.submenuArray.length > 0"
                (click)="toggleSubMenus(4)"
              >
                <ng-container
                  *ngIf="
                    getMenuLink(
                      allMenus[3],
                      companyId == -1 ? '/admin-portal/brands' : '/company-portal/brands'
                    );
                    else noDataRedirect
                  "
                >
                  <a
                    [routerLink]="
                      getMenuLink(
                        allMenus[3],
                        companyId == -1 ? '/admin-portal/brands' : '/company-portal/brands'
                      )
                    "
                    [ngClass]="{ active: isMenuActive(allMenus[3]) }"
                  >
                    <img
                      src="../../../../assets/images/ic_productManagment.svg"
                      style="height: 1.6rem; width: 1.6rem"
                    />
                  </a>
                </ng-container>
                <ng-template #noDataRedirect>
                  <a [ngClass]="{ active: isMenuActive(allMenus[3]) }">
                    <img
                      src="../../../../assets/images/ic_productManagment.svg"
                      style="height: 1.6rem; width: 1.6rem"
                    />
                  </a>
                </ng-template>
                <span class="tool-tip">Data Management</span>
              </li>
            </ng-template>

            <!-- Store Management -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[2].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(3)"
            >
              <ng-container
                *ngIf="
                  getMenuLink(
                    allMenus[2],
                    companyId == -1 ? '/admin-portal/stores' : '/company-portal/stores'
                  );
                  else noStoreRedirect
                "
              >
                <a
                  [routerLink]="
                    getMenuLink(
                      allMenus[2],
                      companyId == -1 ? '/admin-portal/stores' : '/company-portal/stores'
                    )
                  "
                  [ngClass]="{ active: isMenuActive(allMenus[2]) }"
                >
                  <img
                    src="../../../../assets/images/company-management/store_management.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-container>
              <ng-template #noStoreRedirect>
                <a [ngClass]="{ active: isMenuActive(allMenus[2]) }">
                  <img
                    src="../../../../assets/images/company-management/store_management.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-template>
              <span class="tool-tip">Store Management</span>
            </li>

            <!-- Warehouse Management -->
            <li
              hidden
              class="tool-wrap"
              *ngIf="companyId != -1 && allMenus[1].submenus.submenuArray.length > 0"
              (click)="toggleSubMenus(2)"
            >
              <ng-container
                *ngIf="
                  getMenuLink(
                    allMenus[1],
                    companyId == -1 ? '/admin-portal/warehouses' : '/company-portal/warehouses'
                  );
                  else noWarehouseRedirect
                "
              >
                <a
                  [routerLink]="
                    getMenuLink(
                      allMenus[1],
                      companyId == -1 ? '/admin-portal/warehouses' : '/company-portal/warehouses'
                    )
                  "
                  [ngClass]="{ active: isMenuActive(allMenus[1]) }"
                >
                  <img
                    src="../../../../assets/images/ic_warehouse.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-container>
              <ng-template #noWarehouseRedirect>
                <a [ngClass]="{ active: isMenuActive(allMenus[1]) }">
                  <img
                    src="../../../../assets/images/ic_warehouse.svg"
                    style="height: 1.6rem; width: 1.6rem"
                  />
                </a>
              </ng-template>
              <span class="tool-tip">Warehouse Management</span>
            </li>

            <!-- Callback Requests -->
            <ng-template [ngxPermissionsOnly]="['CallbackRequest:View']">
              <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
                <a
                  [routerLink]="'/admin-portal/callback-requests'"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <img
                    style="width: 24px; height: 24px"
                    src="../../../../assets/images/recall.png"
                  />
                </a>
                <span class="tool-tip">Callback Requests</span>
              </li>
            </ng-template>

            <!-- Upload Latest Builds -->
            <li class="tool-wrap" *ngIf="companyId === -1" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="'/admin-portal/upload-latest-build'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <img
                  style="width: 24px; height: 24px"
                  src="../../../../assets/images/upload-sign.svg"
                />
              </a>
              <span class="tool-tip">Upload Latest Builds</span>
            </li>

            <!-- Inventory Management (external) -->
            <li
              class="tool-wrap"
              *ngIf="companyId != -1 && (canShowImsMenu === true)"
              (click)="toggleSubMenus(0); redirectToModule(Apps.IMS)"
            >
              <a routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                <i class="fa-solid fa-warehouse" style="color: #080b12"></i>
              </a>
              <span class="tool-tip">Inventory Management</span>
            </li>
          </ul>

          <!-- Settings -->
          <ul class="list-unstyled mb-0" *ngIf="companyId > 0 || companyId == -1">
            <li class="tool-wrap" (click)="toggleSubMenus(0)">
              <a
                [routerLink]="
                  companyId == -1
                    ? '/admin-portal/settings/datadog-settings'
                    : '/company-portal/settings/company-settings'
                "
                [ngClass]="{ active: settingRoutes.includes(currentRoute) }"
              >
                <img src="../../../../assets/images/duo-icons_settings.svg" />
              </a>
              <span class="tool-tip">Settings</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="w-100">
      <div class="nav-bar d-none d-lg-block">
        <app-navmenu></app-navmenu>
      </div>
      <div class="brij-content d-flex">
        <!-- Submenus -->
        <div
          *ngIf="isExpandSubMenu"
          #submenuSidebar
          [ngStyle]="{ width: isExpandSubMenu ? '20rem' : '0rem' }"
          class="submenus"
        >
          <p class="submenuhead">{{ submenus.menu }}</p>
          <div class="divider"></div>
          <ul class="submenuList">
            <ng-container *ngFor="let mn of submenus.submenuArray">
              <ng-template [ngxPermissionsOnly]="[mn.permission]">
                <li
                  [routerLink]="mn.route"
                  routerLinkActive="subActive"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [hidden]="
                    mn.menu === 'Label Formats' && canShowLabelFormat === false
                  "
                >
                  {{ mn.menu }}
                </li>
              </ng-template>
            </ng-container>
          </ul>
        </div>

        <div [ngStyle]="{ 'flex-basis': !isExpandSubMenu ? '100%' : '85%' }">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
